import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-1 min-w-0 flex flex-col overflow-hidden" }
const _hoisted_2 = { class: "h-16 flex items-center px-6 border-b border-border shrink-0 bg-background" }
const _hoisted_3 = { class: "flex-1 overflow-auto p-6 lg:p-8" }
const _hoisted_4 = { class: "max-w-4xl" }
const _hoisted_5 = { class: "send-card bg-card border border-border shadow-sm p-4 md:p-5 space-y-4" }
const _hoisted_6 = { class: "space-y-1.5" }
const _hoisted_7 = { class: "mb-20 d-flex flex-column" }
const _hoisted_8 = { class: "label-ui" }
const _hoisted_9 = { class: "send-multiselect-wrap relative" }
const _hoisted_10 = { class: "space-y-1.5" }
const _hoisted_11 = { class: "flex items-center gap-2 flex-wrap" }
const _hoisted_12 = { class: "space-y-2" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_15 = { class: "space-y-1.5" }
const _hoisted_16 = { class: "space-y-1.5" }
const _hoisted_17 = { class: "flex justify-end pt-1" }
const _hoisted_18 = { class: "confirm-modal-description" }
const _hoisted_19 = { class: "mb-20" }
const _hoisted_20 = { class: "confirm-modal-value" }
const _hoisted_21 = {
  key: 0,
  class: "mb-20"
}
const _hoisted_22 = { class: "confirm-modal-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EpxEmsRadio = _resolveComponent("EpxEmsRadio")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_select_input = _resolveComponent("select-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_the_modal = _resolveComponent("the-modal")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, { "no-sidebar": false }, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "send-icon-btn lg:hidden mr-3 p-2 hover:bg-accent text-foreground transition-colors",
            "aria-label": "Open menu",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
          }, [...(_cache[11] || (_cache[11] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              class: "h-5 w-5",
              "aria-hidden": "true"
            }, [
              _createElementVNode("path", { d: "M4 5h16" }),
              _createElementVNode("path", { d: "M4 12h16" }),
              _createElementVNode("path", { d: "M4 19h16" })
            ], -1)
          ]))]),
          _cache[12] || (_cache[12] = _createElementVNode("h1", { class: "!text-xl !font-bold !leading-7 text-foreground" }, "Send a Request", -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "label-ui" }, "Send request as", -1)),
                  _createElementVNode("div", null, [
                    _createVNode(_component_EpxEmsRadio, {
                      modelValue: _ctx.selectedEpxEms,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedEpxEms) = $event)),
                      options: _ctx.epxEmsRadioOptions
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, "Send to (" + _toDisplayString(_ctx.selectedEpxEms.toUpperCase()) + " partners)", 1),
                _createElementVNode("div", _hoisted_9, [
                  _cache[14] || (_cache[14] = _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "lucide lucide-search absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground z-10 pointer-events-none",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", { d: "m21 21-4.34-4.34" }),
                    _createElementVNode("circle", {
                      cx: "11",
                      cy: "11",
                      r: "8"
                    })
                  ], -1)),
                  _createVNode(_component_multiselect, {
                    modelValue: _ctx.selectedPartners,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedPartners) = $event)),
                    options: _ctx.selectedEpxEms === 'epx' ? _ctx.partnersOptions : _ctx.partnersEMSOptions,
                    multiple: false,
                    "close-on-select": true,
                    "clear-on-select": false,
                    "preserve-search": true,
                    placeholder: "Type to search...",
                    label: "name",
                    "track-by": "name",
                    "preselect-first": false
                  }, {
                    selection: _withCtx(({ values, isOpen }) => [
                      (values.length)
                        ? _withDirectives((_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "multiselect__single"
                          }, _toDisplayString(values.map(el => el.name).join(', ')), 513)), [
                            [_vShow, !isOpen]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options"])
                ])
              ]),
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "border-t border-border" }, null, -1)),
              _createElementVNode("div", _hoisted_10, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block !text-sm !font-semibold !leading-none text-foreground" }, "Email", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
                  class: "send-input flex h-9 w-full border border-input bg-transparent px-3 py-1 !text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
                  placeholder: "Enter email address",
                  type: "email"
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _cache[22] || (_cache[22] = _createElementVNode("div", { class: "border-t border-border" }, null, -1)),
              _createElementVNode("div", _hoisted_11, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "!text-sm !font-semibold text-foreground" }, "Tags:", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "send-tag",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.message += ' [partner_name] '))
                }, " Partner name "),
                _createElementVNode("button", {
                  type: "button",
                  class: "send-tag",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.message += ' [password] '))
                }, " Password "),
                _createElementVNode("button", {
                  type: "button",
                  class: "send-tag",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.message += ' [expire_in] '))
                }, " Expire in "),
                _createElementVNode("button", {
                  type: "button",
                  class: "send-tag",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.message += ' [url] '))
                }, " Url ")
              ]),
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "border-t border-border" }, null, -1)),
              _createElementVNode("div", _hoisted_12, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block !text-sm !font-semibold !leading-none text-foreground" }, "Message", -1)),
                _createElementVNode("textarea", {
                  class: "send-input flex min-h-[60px] w-full border border-input bg-transparent px-3 py-2 !text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring resize-y",
                  value: _ctx.message,
                  rows: "6",
                  onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onMessageInput($event)))
                }, null, 40, _hoisted_13)
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "border-t border-border" }, null, -1)),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block !text-sm !font-semibold !leading-none text-foreground" }, "Reminders", -1)),
                  _createVNode(_component_select_input, {
                    value: _ctx.reminder,
                    "show-close-button": false,
                    "additional-info": 'Reminders stop when the link expires.',
                    placeholder: "Select reminder frequency",
                    options: [
                    {label: 'No reminders', value: '0'},
                  {label: '1 reminder - After 24 hours', value: '1'},
                  {label: '2 reminders - Every 12 hours', value: '2'},
                  {label: '3 reminders - Every 8 hours', value: '3'},
                  ],
                    onHandleChange: _cache[9] || (_cache[9] = (v) => { _ctx.reminder = v })
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block !text-sm !font-semibold !leading-none text-foreground" }, "Secure URL Expiration", -1)),
                  _createVNode(_component_select_input, {
                    value: String(_ctx.expires),
                    "show-close-button": false,
                    placeholder: "Select expiration time",
                    options: [
                    { label: 'Expires in 12 hours', value: '12' },
                    { label: 'Expires in 1 day', value: '24' },
                    { label: 'Expires in 2 days', value: '48' },
                    { label: 'Expires in 5 days', value: '120' },
                  ],
                    onHandleChange: _cache[10] || (_cache[10] = (v) => { _ctx.expires = Number(v) })
                  }, null, 8, ["value"])
                ])
              ]),
              _cache[25] || (_cache[25] = _createElementVNode("div", { class: "border-t border-border" }, null, -1)),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_base_button, {
                  disabled: (_ctx.selectedPartners === null) || (_ctx.email === ''),
                  class: "button-send-now",
                  onClick: _ctx.openSendNowModal
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode(" Send Now ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_the_modal, {
        "is-visible": _ctx.confirmModal.isOpen.value,
        "min-width": 600,
        onOnCancel: _ctx.confirmModal.close,
        onOnConfirm: _ctx.onSendNow
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[26] || (_cache[26] = _createElementVNode("h4", { class: "confirm-modal-label" }, "Details:", -1)),
                _createElementVNode("p", _hoisted_20, "You are sending a request for information to " + _toDisplayString(_ctx.email) + " for " + _toDisplayString(_ctx.selectedPartners?.name), 1)
              ]),
              (_ctx.reminder !== '0')
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _cache[27] || (_cache[27] = _createElementVNode("h4", { class: "confirm-modal-label" }, "Behavior:", -1)),
                    _createElementVNode("p", _hoisted_22, "They will be reminded to complete their information " + _toDisplayString(_ctx.reminder) + " time in " + _toDisplayString(_ctx.expires) + " hours.", 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_base_button, { onClick: _ctx.onSendNow }, {
            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
              _createTextVNode("Yes, confirm", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_base_button, {
            variant: "outlined",
            class: "mr-20",
            onClick: _ctx.confirmModal.close
          }, {
            default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["is-visible", "onOnCancel", "onOnConfirm"]),
      _createVNode(_component_the_modal, {
        "is-visible": _ctx.successModal.isOpen.value,
        onOnCancel: _ctx.successModal.close,
        onOnConfirm: _ctx.successModal.close
      }, {
        content: _withCtx(() => [...(_cache[30] || (_cache[30] = [
          _createElementVNode("div", { style: {"max-width":"500px"} }, [
            _createElementVNode("h4", { class: "text-center" }, "Your request has been sent.")
          ], -1)
        ]))]),
        footer: _withCtx(() => [
          _createVNode(_component_base_button, { onClick: _ctx.closeSuccessModalAndResetValues }, {
            default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
              _createTextVNode("Done", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["is-visible", "onOnCancel", "onOnConfirm"])
    ]),
    _: 1
  }))
}